/** Thrown when the API returns a failure envelope (`status: false`) or mapped client-side from HTTP errors. */
export class ApiBusinessError extends Error {
  constructor(
    message: string,
    readonly statusCode: number,
    readonly envelope?: unknown,
  ) {
    super(message);
    this.name = 'ApiBusinessError';
    Object.setPrototypeOf(this, ApiBusinessError.prototype);
  }
}

export function isApiBusinessError(err: unknown): err is ApiBusinessError {
  return err instanceof ApiBusinessError;
}
